import { Language } from "src/utils/localization/languages/types";

const ALGOLIA_ENV = process.env.GATSBY_ALGOLIA_ENV;

export const cruiseSearchIndexName = () =>
  `${ALGOLIA_ENV}_cruises_all_languages`;

export const globalSearchIndexName = (language: Language) =>
  `${ALGOLIA_ENV}_global_${language.code}`;

export const pressReleasesIndexName = `${ALGOLIA_ENV}_press_releases`;
